import axios from 'axios';

// Make API call to ipify (https://www.ipify.org/) to get user's IP Address
// As of Jan 2021 there are no limits to the amount of requests per day/month and no account is needed

const apiPath = 'https://api.ipify.org?format=json';

export const getIPAddress = async () => {
  try {
    const res = await axios.get(apiPath);
    if (res.data) return res.data.ip;

    return null;
  } catch (err) {
    console.log('Unable to get user IP address: ', err);
  }
};
